<template>
  <div ref="item" class="nt-template__item" :class="[topMargin, bottomMargin]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nt-template-item',
  props: {
    top: {
      type: String
    },
    bottom: {
      type: String
    },
    fontResize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      topMargin: this.top ? `spacing-top--${this.top}` : null,
      bottomMargin: this.bottom ? `spacing-bottom--${this.bottom}` : null,
      baseFontSize: 16
    }
  },
  methods: {
    onResize() {
      const windowWidth = window.innerWidth
      const componentWidth = this.$refs.item.offsetWidth
      const sm = 768
      // const md = 992
      // const lg = 1200
      const ratio = ((this.baseFontSize * (componentWidth / windowWidth)) * 10)
      if (windowWidth > sm) {
        if (ratio > 100) {
          this.$refs.item.style.fontSize = '100%'
        } else {
          this.$refs.item.style.fontSize = `${ratio < 70 ? '70' : ratio}%`
        }
      } else {
        this.$refs.item.style.fontSize = '100%'
      }
    }
  },
  mounted() {
    if (this.fontResize) {
      window.addEventListener('resize', this.onResize)
      this.onResize()
    }
  }
}
</script>